import { LocationDetail, useCustomer } from "../../contexts/CustomerContext";
import {
  findLoyaltyBusiness,
  groupLocationsByBusiness,
} from "../../utils/loyaltyBusiness";

export type SortMode = "recent" | "az";

const sortLocations = (locations: LocationDetail[], sortMode: SortMode) =>
  [...locations].sort((a, b) => {
    if (sortMode === "az") return a.name.localeCompare(b.name);
    if (a.lastVisit && b.lastVisit)
      return new Date(b.lastVisit).getTime() - new Date(a.lastVisit).getTime();
    if (a.lastVisit) return -1;
    if (b.lastVisit) return 1;
    return a.name.localeCompare(b.name);
  });

/**
 * The portal's location list: shared-loyalty businesses first (one group per
 * business), then standalone locations, then the venues the customer hid.
 */
export function usePortalSections(sortMode: SortMode, hiddenIds: string[]) {
  const { locations, loyaltyBusinesses } = useCustomer();
  const sorted = sortLocations(locations, sortMode);
  const visible = sorted.filter((l) => !hiddenIds.includes(l.id));
  const { groups, standalone } = groupLocationsByBusiness(
    visible,
    loyaltyBusinesses,
  );
  const hidden = sorted
    .filter((l) => hiddenIds.includes(l.id))
    .map((location) => ({
      location,
      sharedLoyalty: !!findLoyaltyBusiness(location.loyalty, loyaltyBusinesses),
    }));

  return { groups, standalone, hidden };
}
